import React, { useEffect, useState } from "react";
import "./index.css";
import DataTableComponent from "../../../components/DataTable";
import KitInfoModal from "../../../components/Common/InfoModal/kitInfo";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Common/Loader/PrimaryLoader";
import { fetchDistributorClientData } from "../../../redux/slice/ClientsDistributorSlice";
import { Badge, Stack } from "@mui/material";
import moment from "moment";
import { formatNumberWithCommas } from "../../../utils/formatNumberWithCommas";

function DistributorClients() {
  const { status, ClientDistributorData } = useSelector(
    (state) => state.DISTRIBUTORCLIENTMANAGEMENT
  );
  const [userListModal, setUserListModal] = useState(false);
  const dispatch = useDispatch();

  const [removeId, setRemoveId] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [showDropCon, setShowDropCon] = useState(false);

  useEffect(() => {
    dispatch(fetchDistributorClientData());
  }, [dispatch]);

  const clickRowHandler = (row) => {
    setUserInfo(row);
    setUserListModal(true);
  };

  const onSelectedCheckboxChange = (check) => {
    const selectedId = check?.selectedRows.map((curElm) => curElm._id);
    if (selectedId.length > 0) {
      setRemoveId(selectedId);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };
  const getBatchCount = (count1 = 0, count2 = 0, count3 = 0) => {
    return (
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        className="border-0"
        style={{ width: "150px" }}
      >
        <Badge
          badgeContent={count1}
          showZero
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#D9F2DD",
              color: "#359742",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              fontSize: "14px",
              position: "relative",
              transform: "none",
            },
          }}
        />
        <Badge
          badgeContent={count2}
          showZero
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#FFF5CC",
              color: "#CCA300",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              fontSize: "14px",
              position: "relative",
              transform: "none",
            },
          }}
        />
        <Badge
          badgeContent={count3}
          showZero
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#FFE5E5",
              color: "#FF6666",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              fontSize: "14px",
              position: "relative",
              transform: "none",
            },
          }}
        />
      </Stack>
    );
  };

  const getAssessmentStatus = (row) => {
    const status = row?.assessmentStatus || "";

    let color = "black";

    if (status.includes("Pending")) {
      color = "#CCA300";
    } else if (status.includes("Not Registered")) {
      color = "#FF6666";
    } else if (status.includes("Complete")) {
      color = "#359742";
    }

    return <span style={{ color }}>{status}</span>;
  };

  const distColumns = [
    {
      name: "Agent",
      selector: (row) => row?.distributor_name,
    },
    {
      name: "Client Business Name",
      selector: (row) => row.company_name,
    },
    {
      name: "Kit Status",
      selector: (row) =>
        getBatchCount(
          row?.kit_count?.compliant ?? 0,
          row?.kit_count?.nearExpiry ?? 0,
          row?.kit_count?.nonCompliant ?? 0
        ),
    },
    {
      name: "Users",
      selector: (row) => formatNumberWithCommas(row?.countOfUsers ?? 0),
    },
    {
      name: "First Aiders",
      selector: (row) =>
        getBatchCount(
          row?.firstAidCertificateUser?.valid ?? 0,
          row?.firstAidCertificateUser?.nearExpiry ?? 0,
          row?.firstAidCertificateUser?.expired ?? 0
        ),
    },
    {
      name: "Last Registration",
      selector: (row) => moment(row.account_creation).format("DD MMMM YYYY"),
    },
    {
      name: "Assessment",
      selector: (row) => getAssessmentStatus(row),
    },
  ];

  if (status === "loading") {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  const userData = ClientDistributorData?.data?.Users || [];

  return (
    <div className="kit-management position-relative flex-grow-1">
      <DataTableComponent
        title={"Tell Arnie Registered Client"}
        search={true}
        searchBy={[
          "company_name",
          "county",
          "country",
          "super_admin",
          "approver",
        ]}
        columns={distColumns}
        data={userData}
        selectedRows={false}
        clickedRow={() => {}}
        checkboxChange={onSelectedCheckboxChange}
        placeholder="Search for client"
      />

      {userListModal && (
        <KitInfoModal
          hide={() => setUserListModal(false)}
          show={userListModal}
          title={"User Information"}
          listingData={userInfo}
        />
      )}
    </div>
  );
}

export default DistributorClients;
